// extracted by mini-css-extract-plugin
export default {"persistentCta":"persistent-cta_persistentCta","collapsedText":"persistent-cta_collapsedText","extra":"persistent-cta_extra"};